module.exports = __webpack_public_path__ + "static/media/josue_mejia_5.980eb9b6.jpg";